import { premiumBuildingsPrices } from "@/config/constants";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class MilitaryAcademyBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MILITARY_ACADEMY;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];
}

export default MilitaryAcademyBuildingTileEntity;
